import React from 'react';
import { RtModal } from '../ui/RtModal';

const DeleteConfirmationModal = ({
  isOpen,
  itemName,
  itemType = 'item',
  onCancel,
  onConfirm,
  isProcessing = false,
}) => {
  if (!isOpen) return null;

  return (
    <RtModal
      open={isOpen}
      onClose={onCancel}
      title="Confirm Deletion"
      size="sm"
      variant="destructive"
      closeDisabled={isProcessing}
      closeOnBackdrop={!isProcessing}
      footer={
        <>
          <button
            type="button"
            className="rt-btn rt-btn--secondary"
            onClick={onCancel}
            disabled={isProcessing}
          >
            Cancel
          </button>
          <button
            type="button"
            className="rt-btn rt-btn--danger"
            onClick={onConfirm}
            disabled={isProcessing}
          >
            {isProcessing ? 'Deleting…' : 'Delete'}
          </button>
        </>
      }
    >
      <div className="rt-modal-confirm">
        <p className="rt-modal-confirm__message">
          Are you sure you want to delete the {itemType}?
        </p>
        {itemName ? (
          <p className="rt-modal-confirm__entity">
            <strong>{itemName}</strong>
          </p>
        ) : null}
      </div>
    </RtModal>
  );
};

export default DeleteConfirmationModal;
